var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13.329,
  height: 19.329,
  viewBox: "0 0 13.329 19.329"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M282.024,1.513v8.665A61.709,61.709,0,0,0,279,4.766V1.513a1.513,1.513,0,1,1,3.027,0Z",
  transform: "translate(-271.313 0)",
  fill: "#e3e3e3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M154.385,34.458l-.906-.906a4.655,4.655,0,0,0-3.314-1.373h-.637L147.7,29.131a1.513,1.513,0,1,1,2.621-1.513C153.353,32.63,152.448,31.1,154.385,34.458Z",
  transform: "translate(-145.316 -25.767)",
  fill: "#e3e3e3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M107.82,179.5a8.639,8.639,0,0,0-.378-2.063l-2.8-2.8a4.036,4.036,0,0,0-2.854-1.182c-3.493,0-3.46-.054-3.885.162a1.515,1.515,0,0,0-.755.871,3,3,0,0,1,2.753,1.994h2.2a3.029,3.029,0,0,1,.915,1.094c.25.565.192.883.192,2.493a1.385,1.385,0,0,1-2.3,1.042,4.363,4.363,0,0,1-1.371-2.271c-.273-1.144.1-1.637-.459-2.567a2.354,2.354,0,0,0-1.807-1.127l-.2-.009c-.017,0-.011-.463-.011,6.055a4.709,4.709,0,0,0,4.708,4.708h1.682a4.061,4.061,0,0,0,2.468-.919h0A7.765,7.765,0,0,0,107.82,179.5Z",
  transform: "translate(-97.071 -166.576)",
  fill: "#e3e3e3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M371.267,81.017c0,.251.123-.282-1.87,7.153V79.778A1.347,1.347,0,0,1,371.267,81.017Z",
  transform: "translate(-357.939 -76.483)",
  fill: "#e3e3e3"
})));
export default __webpack_public_path__ + "static/media/feature-disable.97ba5845.svg";
export { SvgComponent as ReactComponent };